// Public surfaces that are not live yet while Project Leviathan is staged
// (Newsletter is launch-paused) point at the "temporarily unavailable" launch
// page instead of dead-ending on a 404 or a not-yet-redesigned page. Blog
// goes straight to the Project Leviathan announcement. Live surfaces (Pricing,
// Contact, Dashboard, Terms, Discord) keep their real destinations.
//
// This module carries only the links so pages that need the destinations do
// not load the marketing chrome itself.
export const launchUnavailableHref = "/launch-unavailable";
export const blogHref = "/blog/project-leviathan";

export const publicNavLinks = [
  { label: "Home", href: "/" },
  { label: "Approach", href: "/approach" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: blogHref },
  { label: "Newsletter", href: launchUnavailableHref },
  { label: "Discord", href: "https://discord.com/invite/tradewithtitans" },
];
